import axios from "../axiosPlugin.js";

const _OTHER_REVENUE_API = "/api/otherRevenue";

export const getOtherRevenueListService = data => {
  const {
    cinemaId,
    effective,
    name,
    forPos,
    page,
    pageSize,
  } = data;
  let queryString = `cinemaId=${cinemaId}&page=${page}&pageSize=${pageSize}`;
  if (effective) {
    queryString += `&effective=${effective}`;
  }
  if (name) {
    queryString += `&name=${name}`;
  }
  if (forPos) {
    queryString += `&forPos=${forPos}`;
  }
  return axios({
    url: `${_OTHER_REVENUE_API}/list?${queryString}`,
    method: "get",
    data: {},
  });
};

export const createOtherRevenueService = data => {
  return axios({
    url: `${_OTHER_REVENUE_API}/create`,
    method: "post",
    data: { data },
  });
};

export const deleteOtherRevenueService = data => {
  return axios({
    url: `${_OTHER_REVENUE_API}/delete/${data.id}`,
    method: "get",
    data: {},
  });
};

export const updateOtherRevenueService = data => {
  return axios({
    url: `${_OTHER_REVENUE_API}/update`,
    method: "post",
    data: { data },
  });
};

export const getOtherRevenueServiceDetail = data => {
  return axios({
    url: `${_OTHER_REVENUE_API}/detail/${data.id}`,
    method: "get",
    data: {},
  });
};

export const approveOtherRevenueService = data => {
  return axios({
    url: `${_OTHER_REVENUE_API}/approve?cinemaId=${data.cinemaId}`,
    method: "post",
    data: {},
  });
};

export const otherRevenueExportCSVService = data => {
  let queryString = "cinemaId=" + data.cinemaId;
  if (data.name) {
    queryString += "&name=" + data.name;
  }
  return axios({
    url: `${_OTHER_REVENUE_API}/export?${queryString}`,
    method: "get",
    data: {
      data: {
        isDownladFile: true,
      }
    },
  });
};

export const getOtherRevenueReport = data => {
  return axios({
    url: "/api/report/otherRevenueReport",
    method: "get",
    data: {
      data,
    },
  });
};

export const getOtherRevenueRecordDetail = data => {
  return axios({
    url: "/api/transaction/revenueTransactionDetail",
    method: "get",
    data: {
      data,
    },
  });
};

export const createNewOtherRevenueRecord = data => {
  return axios({
    url: "/api/transaction/createOtherRevenueTransaction",
    method: "post",
    data: {
      data,
    },
  });
};

export const updateOtherRevenueRecordService = data => {
  return axios({
    url: "/api/transaction/revenueUpdateTransaction?accountId=" + window.localStorage.getItem("accountId"),
    method: "post",
    data: {
      data
    }
  });
};
